import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { BACKEND } from "../config/configEnvs";
import { FaEdit, FaExclamationCircle, FaUserCircle, FaFilter, FaTrashAlt, FaUserAlt, FaUsers, FaUserTie } from "react-icons/fa";
import { toast } from "react-toastify";
import ModalFilters from "../components/Incidencias/ModalFilters";
import EditButton from "../components/ui/components/EditButton";
import DeleteButton from "../components/ui/components/DeleteButton";
import { Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { FormatDateString, FormatDateStringDDMMYYYY, FormatDateStringGMT5, FormatDateTimeStringGMT5, FormatDateToDDMMYY } from "../utils/FormatDate";
import { useSelector } from "react-redux";


function Trabajadores() {
  const user = useSelector((state) => state.auth.user)
  const [trabajadores, setTrabajadores] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const isRrhh = user.puesto.toUpperCase() === "RRHH"

  const [activeWorkers, setActiveWorkers] = useState(true)

  // Modal de filtros
  const [ openFilter, setOpenFilter ] = useState(false)
  const [ activeCols, setHeadersTableActive ] = useState([]);

  const headers = [
    { id: 0, name: "activo", show: true },
    { id: 1, name: "Foto", show: true },
    { id: 2, name: "DNI", show: true },
    { id: 3, name: "Nombre", show: true },
    { id: 4, name: "Nacimiento", show: true },
    { id: 5, name: "Correo", show: true },
    { id: 6, name: "Número agencia", show: true },
    { id: 7, name: "Estado trabajador", show: true },
    { id: 8, name: "Área", show: true },
    { id: 9, name: "Subárea", show: true },
    { id: 10, name: "Puesto", show: true },
    { id: 11, name: "Género", show: false },
    { id: 12, name: "País", show: false },
    { id: 13, name: "Ciudad", show: false },
    { id: 14, name: "Dirección", show: false },
    { id: 15, name: "Banco", show: true },
    { id: 16, name: "Sueldo", show: true },
    { id: 17, name: "N° cuenta bancaria", show: true },
    { id: 18, name: "N° cuenta interbancaria", show: false },
    { id: 19, name: "Tel. emergencia", show: false },
    { id: 20, name: "Correo personal", show: false },
    { id: 21, name: "Hijos", show: false },
    { id: 22, name: "Mascotas", show: false },
    { id: 23, name: "Grado estudios", show: false },
    { id: 24, name: "Carrera o especialidad", show: false },
    { id: 25, name: "Vínculo Laboral", show: true },
    { id: 26, name: "Discapacidad", show: false },
    { id: 27, name: "Hobbies", show: false },
    { id: 28, name: "Link Facebook", show: false },
    { id: 29, name: "Link Instagram", show: false },
    { id: 30, name: "Link Linkedin", show: false },
    { id: 31, name: "Edad", show: true },
  ];

  useEffect(() => {
    setHeadersTableActive(headers);
  }, []);

  const fetchTrabajadores = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0`);
      const allworkers = response.data.docs;

      const filteredWorkers = allworkers.filter(worker => 
        worker.puesto?.toUpperCase()?.trim() !== "GERENTE GENERAL" &&
        worker.puesto?.toUpperCase()?.trim() !== "JEFE DE PROYECTOS"
      );
      setTrabajadores(filteredWorkers);
    } catch (error) {
      toast.error("Error obteniendo a los trabajadores: " + error);
    }
  };

  useEffect(() => {
    fetchTrabajadores()
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredByStatus = trabajadores.filter((trabajador) => {
    if (activeWorkers) {
      return trabajador.activo === true; 
    } else {
      return trabajador.activo === false;
    }
  });

  const filteredRegistros = filteredByStatus.filter((trabajador) => {
    const searchTermLower = searchTerm.toLowerCase();
    return trabajador.name?.toLowerCase().includes(searchTermLower);
  });

  const formatToReadableDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString(); 
  };

  const calculateAge = (birthDate) => {
    if (!birthDate) return "";
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  return (
    <div className="flex flex-col h-screen w-full">
      
      <ModalFilters 
        open={openFilter}
        setOpen={setOpenFilter}
        activeCols={activeCols}
        setActiveCols={setHeadersTableActive}
      />
      
      {/* Header */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="flex items-center gap-4 p-4">
            <FaUsers className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">Trabajadores</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 gap-2 items-center justify-center">
              <span className="font-medium">Trabajadores activos</span>
              <input
                type="checkbox"
                className="rounded-md border-gray-400 hover:cursor-pointer"
                checked={activeWorkers}
                onChange={(e) =>
                  setActiveWorkers(e.target.checked)
                }
              />
            </div>
            
            <div className="mx-4">
              <input
                type="text"
                placeholder="Buscar trabajador"
                value={searchTerm}
                onChange={handleSearch}
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              />
            </div>
            
            <Link
              to="/home/trabajadores/nuevo-trabajador"
            >
              <Button
                variant="contained"
                endIcon={<AddIcon/>}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  whiteSpace: "nowrap",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
              >
                Añadir trabajador
              </Button>
            </Link>
            <button className="text-orange-600 bg-orange-500 bg-opacity-10 hover:bg-opacity-20 rounded-md p-2" type="button" onClick={() => setOpenFilter(true)}>
              <FaFilter className="text-xs" />
            </button>

          </div>
        </div>
      </div>

      {/* Data bar */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 w-full">
        <div className="w-full items-center justify-center overflow-x-auto py-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-8 min-w-max px-4 items-center justify-center">   
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="font-medium">Total trabajadores:</span>
              <span>{filteredByStatus.length}</span>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="font-medium">Planilla:</span>
              <span>{filteredByStatus.reduce((acc, trabajador) => acc + trabajador.sueldo, 0).toLocaleString("es-PE", { style: "currency", currency: "PEN" })}</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Body */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">

          <thead className="sticky top-0 text-gray-900 bg-gray-200 text-[10px] z-20">
            <tr className="text-gray-700 text-center font-bold">
              <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                Acciones
              </td>
              {activeCols.find((e) => e.id === 1)?.show && (  
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Foto</td>
              )}
              {activeCols.find((e) => e.id === 2)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">DNI</td>
              )}
                {activeCols.find((e) => e.id === 3)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Nombre</td>
              )}
                {activeCols.find((e) => e.id === 4)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Nacimiento</td>
              )}
                {activeCols.find((e) => e.id === 31)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Edad</td>
              )}
                {activeCols.find((e) => e.id === 5)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Correo</td>
              )}
                {activeCols.find((e) => e.id === 6)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Número agencia</td>
              )}
                {activeCols.find((e) => e.id === 7)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Estado</td>
              )}
                {activeCols.find((e) => e.id === 8)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Area</td>
              )}
                {activeCols.find((e) => e.id === 9)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Subarea </td>
              )}
                {activeCols.find((e) => e.id === 10)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Puesto </td>
              )}
                {activeCols.find((e) => e.id === 11)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Género </td>
              )}
                {activeCols.find((e) => e.id === 12)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">País</td>
              )}
                {activeCols.find((e) => e.id === 13)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Ciudad</td>
              )}
                {activeCols.find((e) => e.id === 14)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Direccion</td>
              )}
                {activeCols.find((e) => e.id === 15)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Banco</td>
              )}
                {activeCols.find((e) => e.id === 16)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Sueldo</td>
              )}
                {activeCols.find((e) => e.id === 17)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">N° cuenta bancaria</td>
              )}
                {activeCols.find((e) => e.id === 18)?.show && (            
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">N° cuenta interbancaria</td> 
              )} 
                {activeCols.find((e) => e.id === 19)?.show && (            
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Tel. emergencia</td>
              )}
                {activeCols.find((e) => e.id === 20)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Correo personal</td>
              )}
                {activeCols.find((e) => e.id === 21)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Hijos</td>
              )}
                {activeCols.find((e) => e.id === 22)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Mascotas</td>
              )}
                {activeCols.find((e) => e.id === 23)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Grado estudios</td>
              )}
                {activeCols.find((e) => e.id === 24)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Carrera o especialidad</td>
              )}
                {activeCols.find((e) => e.id === 25)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Vinculo Laboral</td>
              )}
                {activeCols.find((e) => e.id === 26)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Discapacidad</td>
              )}
                {activeCols.find((e) => e.id === 27)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Hobbies</td>
              )}
                {activeCols.find((e) => e.id === 28)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Link Facebook</td>
              )}
                {activeCols.find((e) => e.id === 29)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Link Instagram</td>
              )}
                {activeCols.find((e) => e.id === 30)?.show && (
                 <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">Link Linkedin</td>
              )}


            </tr>
          </thead>

          <tbody>
            {filteredRegistros.map((trabajador, index) => {
              return (
                <tr
                  key={trabajador.id}
                  className="hover:bg-gray-100 transition-colors duration-100 text-xs"
                >

                  <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                    <div className="flex items-center justify-center gap-2">
                      <Link to={`/home/trabajadores/editar-trabajador/${trabajador.id}`}>
                        <EditButton content="Editar trabajador" />
                      </Link>
                      {!isRrhh && (
                        <DeleteButton content="Eliminar trabajador" />
                      )}
                    </div>
                  </td>

                  {activeCols.find((e) => e.id === 1)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      <div className="w-8 h-8 rounded-full overflow-hidden">
                        {trabajador.foto?.url ? (
                          <img
                            src={trabajador.foto.url}
                            alt="Foto de perfil"
                            className="w-full h-full object-cover z-10"
                          />
                        ) : (
                          <FaUserCircle className="w-8 h-8 text-gray-500" />
                        )}
                      </div>
                    </td>
                  )}
                  {activeCols.find((e) => e.id === 2)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.dni}
                    </td>
                  )}
                  {activeCols.find((e) => e.id === 3)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.name}
                    </td>
                  )}                    
                  {activeCols.find((e) => e.id === 4)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {FormatDateStringDDMMYYYY(trabajador.birthday)}
                    </td>
                  )}
                  {activeCols.find((e) => e.id === 31)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {(() => {
                        const age = calculateAge(trabajador.birthday);
                        return age !== "" ? `${age} años` : "";
                      })()}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 5)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.email}
                    </td>
                  )}          
                    {activeCols.find((e) => e.id === 6)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.numeroAgencia}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 7)?.show && (
                    <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 font-bold text-center ${trabajador.activo ? "text-green-500" : "text-red-500"}`}>
                      {trabajador.activo ? "Activo" : "Inactivo"}
                    </td>
                  )}
                  {activeCols.find((e) => e.id === 8)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.area}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 9)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.subarea}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 10)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.puesto}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 11)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.sexo}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 12)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.pais}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 13)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.ciudad}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 14)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.direccion}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 15)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.banco}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 16)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      S/. {trabajador.sueldo}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 17)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.cuentaBancaria}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 18)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.cuentaInterbancaria}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 19)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.telefonoEmergencia}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 20)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.correoPersonal}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 21)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.hijos}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 22)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.mascotas}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 23)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.gradoEstudios}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 24)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.carreraEspecialidad}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 25)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.vinculoLaboral}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 26)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.discapacidad}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 27)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      {trabajador.hobbies}
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 28)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      <a
                        href={trabajador.linkFacebook}
                        className="text-blue-500 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {trabajador.linkFacebook}
                      </a>
                    </td>
                  )}
                    {activeCols.find((e) => e.id === 29)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      <a
                        href={trabajador.linkInstagram}
                        className="text-blue-500 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {trabajador.linkInstagram}
                      </a>
                    </td>
                  )}
                  {activeCols.find((e) => e.id === 30)?.show && (
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      <a
                        href={trabajador.linkLinkedin}
                        className="text-blue-500 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {trabajador.linkLinkedin}
                      </a>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>

        </table>
      </div>

    </div>
  );
}

export default Trabajadores;
